// extracted by extract-css-chunks-webpack-plugin
module.exports = {"delete-icon":"styles__delete-icon___1jQrC","deleteIcon":"styles__delete-icon___1jQrC","delete-button":"styles__delete-button___1_ym2","deleteButton":"styles__delete-button___1_ym2"};
    if(module.hot) {
      // 1765844149808
      var cssReload = require("../../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  